import React from "react";
import { ApparecchioCategory, ImpiantoClimaDto, ImpiantoLight } from "../../generated";
import ImpiantiStore from "../ImpiantiClimaStore";
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import { RapportoControlloModalSelector } from "../../rapporticontrollo/components/rapportoControlloModalSelector";
import ModelloClimaData from "../../modelliClima/components/ModelloClimaData";
import ApparecchioTypeIcon from "../../impianti/components/apparecchioTypeIcon";
import ImpiantiActions from "../ImpiantiClimaActions";
import { withApparecchioCateogories } from "../../impianti/withApparecchioCategories";
import { Dictionary } from "../../common/AbstractStores";
import { Loading } from "../../common/components/loading";
import { ToImpiantoData } from "./impiantoClimaForm";
import DeleteImpiantoClimaButton from "./deleteImpiantoClimaButton";
import StringsHelper from "../../common/stringsHelper";
import LinkableApparecchiButton from "./LinkableApparecchiButton";
interface Props {
    impiantoData: ImpiantoLight;
    apparecchioCategories: Dictionary<ApparecchioCategory>,
    inGroup?: boolean
}
export const ImpiantoClimaWidget = withApparecchioCateogories((props: Props) => {
    const { idCliente, id, type } = props.impiantoData;
    const impianto = ImpiantiStore.use(id);
    if (impianto == null)
        return <Loading />


    const onRestoreImpianto = async (impianto: ImpiantoClimaDto) => {
        impianto.dismesso = false;
        await ImpiantiActions.update(ToImpiantoData(impianto), impianto.id);
    }
    return (
        <div className={`card ${props.inGroup ? "mb-0 border-0 border-bottom" : ""}`} style={{ width: 400 }}>
            <div className="card-body position-relative" style={{ minHeight: 100 }}>
                <div className="row align-items-center justify-content-center">
                    <div className="col-auto">
                        <div className="card-img p-2" style={{ width: 50, height: 50 }}>
                            <ApparecchioTypeIcon apparecchioType={type} color={impianto.dismesso ? "#fc4b6c" : undefined} height={50} width={50} />
                        </div>
                    </div>
                    <div className="col">
                        <Link className="stretched-link" to={links.impiantoClimaEdit(id)} />
                        <div className="row no-gutter">
                            <div className="col d-flex text-uppercase flex-wrap align-items-center">
                                <ModelloClimaData
                                    id={impianto.idApparecchio}
                                    template={c => <>
                                        <h3 className={`mb-0 me-1 ${impianto.dismesso ? "text-danger" : ""}`}>{c.marca}</h3>
                                        <h4 className={`mb-0 me-2 ${impianto.dismesso ? "text-danger" : ""}`}>{c.modello}</h4>
                                    </>}
                                />
                                {
                                    impianto.dismesso && <div className="row no-gutter text-end text-danger">
                                        <div className="col-12">
                                            <span className="badge bg-danger" style={{ fontSize: "1rem" }}>
                                                Dismesso
                                            </span>
                                        </div>
                                    </div>
                                }
                                <span className="col-auto ms-auto">
                                    <i className="fas fa-fire text-primary me-2" />
                                    <span title="Potenza Utile">
                                        {impianto.potenzaTermicaNominale && impianto.potenzaTermicaNominale > 0
                                            ? StringsHelper.toDecimalString(impianto.potenzaTermicaNominale)
                                            : "N.C."}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="row no-gutter">
                            <div className="col d-flex justify-content-between">
                                <div className="d-flex flex-column">
                                    {impianto.matricola && <>
                                        <small><strong>Matricola </strong></small>
                                        {impianto.matricola}
                                    </>}
                                </div>
                                <div className="d-flex flex-column text-end">
                                    {impianto.codiceImpiantoCatasto && <>
                                        <small><strong>Cod.Targa </strong></small>
                                        {impianto.codiceImpiantoCatasto}
                                    </>}
                                </div>
                            </div>
                        </div>
                        {impianto.noteImpianto && <div><small>Nota: {impianto.noteImpianto}</small></div>}
                    </div>
                </div>
            </div>
            <div className={`card-footer ${props.inGroup ? "border-0" : ""}`}>
                <div className="row justify-content-center align-items-center flex-nowrap">
                    <div className="col-auto">
                        <RapportoControlloModalSelector
                            idImpianto={impianto.id}
                            idCliente={idCliente}
                            className="btn btn-outline-secondary me-1"
                        />
                        <LinkableApparecchiButton current={props.impiantoData} />
                        {impianto.dismesso && <button className="btn btn-success"
                            onClick={() => onRestoreImpianto(impianto)}>
                            <i className="fas fa-check-square" /> <span className="hidden-sm-down">Ripristina</span>
                        </button>}
                        {!impianto.dismesso && <DeleteImpiantoClimaButton impianto={impianto} />}
                    </div>
                </div>
            </div>
        </div >
    );
})(x => x.allByKey(), "apparecchioCategories");